import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { InfoTooltip } from '@/components/help/InfoTooltip';

type SectionHeadingWithHintProps = {
  title: string;
  hint: string;
  icon?: ReactNode;
  className?: string;
  /** e.g. mb-4 */
  headingClassName?: string;
  actions?: ReactNode;
};

/**
 * Section title with optional icon, info tooltip, and right-side actions (same row on sm+).
 */
export function SectionHeadingWithHint({
  title,
  hint,
  icon,
  className,
  headingClassName,
  actions,
}: SectionHeadingWithHintProps) {
  return (
    <div className={cn('mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', className)}>
      <h2
        className={cn(
          'flex flex-wrap items-center gap-2 text-lg font-semibold text-foreground',
          headingClassName
        )}
      >
        {icon}
        <span>{title}</span>
        <InfoTooltip text={hint} />
      </h2>
      {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}
